import { render, staticRenderFns } from "./CcPreview.ts.vue?vue&type=template&id=cddac096"
import script from "./CcPreview.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcPreview.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcPreview.ts.vue?vue&type=style&index=0&id=cddac096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports